export const ttpKeys = {
  all: ["ttp"] as const,
};
